module.exports = __webpack_public_path__ + "static/media/notJust.6cdd0717.png";